import React from 'react'

const APIIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.5C9.46457 0.5 10.8627 2.18288 11.066 4.21524L11.1282 4.21524C12.4708 4.21524 13.5982 5.16323 13.9127 6.44416C13.764 6.35251 13.6068 6.27338 13.4477 6.20517C13.2363 6.11456 13.0058 6.03661 12.7607 5.97211C12.3983 5.43762 11.8003 5.09024 11.1282 5.09024L11.066 5.09024C10.6165 5.09025 10.2401 4.74964 10.1954 4.30235C10.0185 2.53431 8.84498 1.375 7 1.375C5.15031 1.375 3.9822 2.5264 3.80465 4.30228C3.75993 4.74961 3.38352 5.09025 2.93397 5.09024L2.87181 5.09024C1.77467 5.09024 0.875 6.01593 0.875 7.17012C0.875 8.3243 1.77467 9.25 2.87179 9.25H7V10.125H2.87179C1.28575 10.125 0 8.80205 0 7.17012C0 5.59258 1.20146 4.30378 2.71424 4.21961L2.93399 4.21524C3.13851 2.16952 4.53544 0.5 7 0.5ZM13.5371 10.3722C12.8282 10.7772 11.9072 11 10.9375 11C9.96775 11 9.04679 10.7772 8.33786 10.3722C8.17936 10.2816 8.02249 10.1758 7.875 10.0552V12.75C7.875 13.7165 9.24613 14.5 10.9375 14.5C12.6289 14.5 14 13.7165 14 12.75V10.0552C13.8525 10.1758 13.6956 10.2816 13.5371 10.3722ZM10.9375 6.625C9.24613 6.625 7.875 7.4085 7.875 8.375C7.875 9.3415 9.24613 10.125 10.9375 10.125C12.6289 10.125 14 9.3415 14 8.375C14 7.4085 12.6289 6.625 10.9375 6.625Z"
        fill="#4D4D4D"
      />
    </svg>
  )
}

export default APIIcon
